export const SITE_URL = "https://trendy-eng-shop.ru/";
export const PD_EMAIL = "igor.kazakov.evg@mail.ru";

export const OPERATOR = {
  shortName: "ИП Казаков И. Е.",
  fullName: "ИП Казаков Игорь Евгеньевич",
  inn: "660901997402",
  ogrnip: "322665800098991",
  registryNumber: "66-25-031034",
};

export const SELLER_NAME = "ООО «Нивад»";

export const PRIVACY_PATH = "/privacy";
export const CONSENT_PATH = "/consent";
export const OFFER_PATH = "/offer#offer";
